module.exports = __webpack_public_path__ + "static/media/square-black.2908aafa.png";